import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Icon } from '@/components/Icons';

interface State {
  hasError: boolean;
  message: string | null;
}

/** حاجز أخطاء عام: لا يعرض تفاصيل حساسة، ويسمح بإعادة التحميل دون مسح البيانات. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { hasError: false, message: null };

  static getDerivedStateFromError(error: unknown): State {
    return {
      hasError: true,
      message: error instanceof Error ? error.message : 'خطأ غير متوقع',
    };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // لا نُسجّل بيانات المهام أو الجلسة؛ فقط رسالة الخطأ والمكوّن.
    console.error('UI error boundary', error.message, info.componentStack?.split('\n')[1] ?? '');
  }

  override render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="boot-screen">
        <div className="card" style={{ maxWidth: 460 }}>
          <div className="card-body col" style={{ gap: 14, textAlign: 'center' }}>
            <span style={{ color: 'var(--danger)' }}>
              <Icon name="alert" size={34} />
            </span>
            <h1 style={{ fontSize: 20 }}>حدث خطأ غير متوقع</h1>
            <p className="small muted">
              لم تُمسح بياناتك. أعد تحميل التطبيق. إذا تكرر الخطأ، أبلغ مسؤول النظام بالوقت
              والمكان دون مشاركة كلمات المرور أو رموز الوصول.
            </p>
            {import.meta.env.DEV && this.state.message ? (
              <pre className="code-block" dir="ltr">
                {this.state.message}
              </pre>
            ) : null}
            <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
              إعادة تحميل التطبيق
            </button>
          </div>
        </div>
      </div>
    );
  }
}
